import React from 'react'
import { Text, View } from '@/components'
import { RenderItemProps } from './types'
import { DebugItem, FeedDimensions } from './shared'
import { variantProvider } from '@/app'
import { QuizQuestion } from '@/types'
import { locationPath } from '@/utils'
import { saveFeedScrollPosition } from '../feedScroll'
import { analytics } from '@/services'
import { Learn } from '@/features'

export const FeedLesson = (props: RenderItemProps) => {
  const { item, contentOverlay } = props
  const lesson = item?.lesson
  const question = lesson?.page?.question as unknown as QuizQuestion

  const currentPage = item?.lesson?.page?.order ?? 1

  function openLesson() {
    saveFeedScrollPosition()
    locationPath.registerCurrentPath()
    analytics.track('lesson_from_feed')
    Learn.tryOpenLesson(lesson.id, currentPage, 'feed')
    return
  }

  return (
    <>
      <DebugItem {...props} />

      {/* <FeedTextOverlay
        title={item.lesson?.title}
        description={item.lesson?.description}
      /> */}
      {contentOverlay}

      <View style={styles.wrapper}>
        <View style={styles.header}>
          <Learn.LessonPaginationIndicator pages={item.lesson_page_count + 2} currentPage={currentPage + 1} />
          <Text
            variants={['h5', 'color:neutral1', 'paddingTop:2', 'marginLeft:auto', 'textRight']}
            style={styles.title}
            text={item.lesson.module_title}
          />
        </View>

        <Learn.LessonContextProvider>
          <Learn.LessonViewContent.Img style={styles.img} question={question} page={lesson?.page} />

          <Learn.LessonViewContent.Body question={question} page={lesson?.page}>
            <Learn.LessonViewContent.Quiz question={question} page={lesson?.page} />
          </Learn.LessonViewContent.Body>

          <Learn.LessonViewContent.Video page={lesson?.page} />
        </Learn.LessonContextProvider>
      </View>

      <View style={styles.overlay} onClick={openLesson} />

      <Learn.LessonViewContent.QuizFeedback question={question} onNext={openLesson} />
    </>
  )
}

const styles = variantProvider.createComponentStyle(
  theme => ({
    wrapper: {
      height: FeedDimensions.HEIGHT,
      width: FeedDimensions.WIDTH,
      ...theme.presets.center,
      ...theme.presets.relative,
      ...theme.spacing.padding(2),
      pointerEvents: 'none',

      [theme.media.down(FeedDimensions.mobileBreakpoint)]: {
        width: FeedDimensions.WIDTH_WITHOUT_SPACING,
        height: FeedDimensions.HEIGHT_WITHOUT_SPACING
      }
    },
    header: {
      ...theme.presets.column,
      ...theme.presets.absolute,
      top: theme.spacing.value(2),
      right: theme.spacing.value(2),
      left: theme.spacing.value(2)
    },
    img: {
      ...theme.presets.fullWidth,
      objectFit: 'contain'
    },
    title: {
      width: '80%',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    overlay: {
      ...theme.presets.absolute,
      ...theme.presets.whole,
      zIndex: 3,
      cursor: 'pointer'
    }
  }),
  true
)
